
import { Header } from '../../components/feature/Header';
import { HeroSection } from './components/HeroSection';
import { ServicesSection } from './components/ServicesSection';
import { AboutSection } from './components/AboutSection';
import { BrandsSection } from './components/BrandsSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from '../../components/feature/Footer';
import { useEffect } from 'react';

export default function Home() {
  useEffect(() => {
    // Update meta tags
    document.title = 'Instalatér a Topenář Mladá Boleslav | Šnajdr';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Havarijní služba voda, topení, plyn. 💧 Spolehlivý instalatér pro Mladou Boleslav a okolí. Opravy, montáže kotlů i čištění odpadů. Volejte 720 520 035.');
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'instalatér mladá boleslav, topenář, havarijní služba voda, výměna kotle, čištění odpadů, rekonstrukce koupelny');
    }
    
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', import.meta.env.VITE_SITE_URL || 'https://example.com');
    }

    // Add Schema.org JSON-LD for LocalBusiness
    const existingScript = document.querySelector('script[type="application/ld+json"][data-page="home"]');
    if (existingScript) {
      existingScript.remove();
    }
    
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-page', 'home');
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "TopInstal Šnajdr",
      "image": "https://static.readdy.ai/image/cd36f9883938bafd66620af1a497dfc4/fb467e4e7a399168a060cedfdb073e6f",
      "description": "Havarijní služba voda, topení, plyn. Spolehlivý instalatér pro Mladou Boleslav a okolí. Opravy, montáže kotlů i čištění odpadů.",
      "url": import.meta.env.VITE_SITE_URL || 'https://example.com',
      "telephone": "+420720520035",
      "email": "instatop.snajdr@post.cz",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Vinec 57",
        "addressLocality": "Mladá Boleslav",
        "postalCode": "293 01",
        "addressRegion": "Středočeský kraj",
        "addressCountry": "CZ"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "50.4113",
        "longitude": "14.9033"
      },
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          "opens": "07:00",
          "closes": "17:00"
        }
      ],
      "priceRange": "$$",
      "areaServed": {
        "@type": "City",
        "name": "Mladá Boleslav"
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Instalatérské a topenářské služby",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Instalatérské práce",
              "description": "Kompletní instalatérské služby včetně vodovodních instalací, oprav a údržby"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Topenářské práce",
              "description": "Instalace a servis topných systémů, podlahové vytápění, radiátory"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Plynové instalace",
              "description": "Odborné plynové instalace a revize"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Havarijní služba",
              "description": "Pohotovostní služba 24/7 pro naléhavé situace"
            }
          }
        ]
      }
    });
    document.head.appendChild(script);
    
    return () => {
      const scriptToRemove = document.querySelector('script[type="application/ld+json"][data-page="home"]');
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, []);

  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <ServicesSection />
        <AboutSection />
        <BrandsSection />
        <ContactSection />
      </main>
      <Footer />
      
      {/* Floating Call Button - Mobile Only */}
      <a
        href="tel:+420720520035"
        className="md:hidden fixed bottom-6 right-6 w-16 h-16 bg-orange-500 text-white rounded-full shadow-2xl flex items-center justify-center z-40 hover:bg-orange-600 transition-all duration-300 hover:scale-110 cursor-pointer animate-pulse"
        aria-label="Zavolat"
      >
        <i className="ri-phone-line text-2xl"></i>
      </a>
    </>
  );
}
